import {ChangeDetectorRef, Component} from '@angular/core';
import {PermissionService} from "../../services/permission.service";
import {AbstractProdGrid, IProdGrid, ProdGridColumnType} from 'prod-grid';
import {DipColumn} from "../../dip/dip-column";

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html'
})
export class PermissionComponent extends AbstractProdGrid implements IProdGrid {
  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'id', type: ProdGridColumnType.ID}),
    DipColumn.get({property: 'name', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'description', type: ProdGridColumnType.STRING})
  ];

  constructor(protected override changeDetectorRef: ChangeDetectorRef, override prodGridDataService: PermissionService) {
    super(changeDetectorRef);
  }

  prodGridTitle: string;

}
